module.exports = __webpack_public_path__ + "img/nodata.b9326baf.png";